




































































































































import {
  Filtro,
  MensagemPronta,
  MensagemProntaService,
} from "@/services/mensagem-pronta.service";
import DataTable from "@/shared/components/data-table.vue";
import Loading from "@/shared/components/loading.vue";
import { Paginacao } from "@/shared/interface";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { required } from "@/shared/validators";
import { Component, Mixins, Ref } from "vue-property-decorator";

import Confirm from "@/shared/components/confirm.vue";
import { DataTableHeader } from "vuetify";
import AlterarMensagemPronta from "../modals/AlterarMensagemPronta.vue";

@Component({
  components: { Loading, DataTable, Confirm, AlterarMensagemPronta },
})
export default class CadastrosMensagensLeads extends Mixins(GlobalMixin) {
  @Ref() readonly alterarMensagemPronta!: AlterarMensagemPronta;
  @Ref() readonly confirm!: Confirm;

  loading = false;
  panel = [0, 1];
  mensagemPronta: MensagemPronta | null = null;
  titulo = "";
  idMensagemOcta = "";
  text = "";
  snackbar = false;
  promise: Promise<Paginacao<MensagemPronta>> | null = null;

  filtro: Filtro = {
    term: "",
    offset: 0,
    limit: 100,
    order: "",
  };

  rules = {
    idMensagemOcta: [required()],
    titulo: [required()],
  };

  headers: DataTableHeader[] = [
    { value: "idMensagemOcta", text: "ID do Octadesk" },
    { value: "tituloMensagem", text: "Mensagens Prontas" },
    { value: "actions", text: "", sortable: false, width: "110px" },
  ];

  editar(mensagemPronta: MensagemPronta) {
    this.alterarMensagemPronta.abrirModal(mensagemPronta.idMensagemPronta);
  }

  async excluir(mensagemPronta: MensagemPronta) {
    const title = "Excluir mensagem pronta?";
    const text = "Deseja realmente excluir esta mensagem pronta?";
    const res = await this.confirm.open(title, text);
    if (res) {
      try {
        this.startLoader();
        await MensagemProntaService.excluirMensagem(
          mensagemPronta.idMensagemPronta
        );
        this.fetchMensagensLeads();
      } finally {
        this.stopLoader();
      }
    }
  }

  mounted() {
    this.filtro.term = "";
  }

  fetchMensagensLeads(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = MensagemProntaService.listarMensagensProntas(this.filtro);
  }

  async cadastrarMensagem() {
    this.mensagemPronta = {} as MensagemPronta;
    const form = this.$refs.formCadastro as any;
    this.mensagemPronta.idMensagemOcta = this.idMensagemOcta;
    this.mensagemPronta.tituloMensagem = this.titulo;

    if (form.validate()) {
      if (this.mensagemPronta) {
        this.loading = true;
        try {
          await MensagemProntaService.manterMensagemPronta(this.mensagemPronta);
        } finally {
          this.loading = false;
          form.reset();
          this.fetchMensagensLeads();
          this.text = "Mensagem Cadastrada!";
          this.snackbar = true;
        }
      }
    }
  }
}
